<script>
// eslint-disable-next-line
import { RectangleStencil } from 'vue-advanced-cropper';

export default {
  // CANNOT be called "CircleStencil" as it clashes with
  // vue advanced cropper's CircleStencil.
  name: 'SlSquareStencil',
  extends: RectangleStencil,
  methods: {
    aspectRatios() {
      const max = 1;
      return {
        minimum: 1 / max,
        maximum: max,
      };
    },
  },
};

</script>
